import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { gsap } from "gsap";
import axios from "axios";
import VueAxios from "vue-axios";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "@/js/typekit.js";
import homelist from "./js/home-list";
import VueSmoothScroll from "vue3-smooth-scroll";
gsap.registerPlugin(ScrollTrigger);

import VueGtag from "vue-gtag";

const app = createApp(App);
app.use(VueAxios, axios);
app.use(router);
app.use(VueSmoothScroll);
app.use(VueGtag, { config: { id: "G-RP5EQHDJDL" } });
app.config.globalProperties.$alllist = homelist;
app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith("a-");
app.mount("#app");
